export default __webpack_public_path__ + "static/media/hospital.983f9548.png";